import {
	reel_column_1,
	reel_column_2,
	reel_column_3,
	reel_column_4,
	reel_column_5
} from './reels/ReelColumnView';

export const ProgressiveBonusSlide_1 = {
	name: 'progressive_bonus_slide_1',
	posisiton: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'slider_bg_title',
			type: 'Text',
			text: 'SPLASH_SLIDE_TITLE_2',
			position: { x: 982 / 2, y: 25 },
			anchor: { x: 0.5, y: 0 }
		},
		{
			name: 'reel_column_1',
			type: 'VisualComponent',
			component: reel_column_1
		},
		{
			name: 'reel_column_1',
			type: 'VisualComponent',
			component: reel_column_2
		},
		{
			name: 'reel_column_1',
			type: 'VisualComponent',
			component: reel_column_3
		},
		{
			name: 'reel_column_1',
			type: 'VisualComponent',
			component: reel_column_4
		},
		{
			name: 'reel_column_1',
			type: 'VisualComponent',
			component: reel_column_5
		}
	]
};
